import { Box, Typography } from '@mui/material';
import { FadeIn } from '../../ui/FadeIn';
import { ProofBar } from './ProofBar';
import { ProofBarItem } from '../../../lib/social-proof';

interface PricingTabHeaderProps {
    title: string;
    description: string;
    proofBarItems: ProofBarItem[];
    /**
     * Optional margin bottom for the text container.
     * Defaults to 6.
     */
    textMb?: number;
}

export function PricingTabHeader({
    title,
    description,
    proofBarItems,
    textMb = 6
}: PricingTabHeaderProps) {
    return (
        <FadeIn direction="up">
            <Box sx={{ textAlign: "center", mb: textMb }}>
                <Typography variant="h2" sx={{ mb: 2, fontWeight: 700 }}>
                    {title}
                </Typography>
                <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{ maxWidth: 700, mx: "auto", fontSize: '1.1rem' }}
                >
                    {description}
                </Typography>
            </Box>

            <Box sx={{ mb: 6 }}>
                <ProofBar items={proofBarItems} />
            </Box>
        </FadeIn>
    );
}
